<template>
  <v-container class="py-0 my-2" id="portal-applicants" v-if="applicants.length">
    <v-row>
      <v-col cols="6" sm="6" md="6" lg="4" class="py-1 px-1" v-if="edit">
        <v-btn
          small
          block
          @click="selected_applicant=null"
          :outlined="selected_applicant ?true : false"
          color="orange"
          dark
        >Edit Portal</v-btn>
      </v-col>
      <v-col
        v-for="(applicant) in applicants"
        :key="applicant.uid"
        cols="6"
        sm="6"
        md="6"
        lg="4"
        class="py-1 px-1"
      >
        <v-btn
          small
          @click="selected_applicant=applicant"
          color="green"
          dark
          block
          :outlined="selected_applicant ? selected_applicant.uid!==applicant.uid ? true : false : true"
        >
          <span
            :style="$vuetify.breakpoint.name==='xs' ? 'font-size:10px' : 'font-size:14px' "
          >{{applicant.name.length > 16 ? applicant.name.slice(0,16)+"..." : applicant.name}}</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: ["value", "items", "edit"],
  name: "PortalApplicants",
  data() {
    return {
      selected_applicant: null
    };
  },
  created() {
    if (!this.edit) {
      this.selected_applicant = this.applicants[0];
    }
  },
  watch: {
    selected_applicant: function() {
      this.$emit("input", this.selected_applicant);
    }
  },
  computed: {
    applicants() {
      return this.items;
    }
  }
};
</script>
<style lang="scss" scoped>
#portal-applicants {
  overflow-y: auto;
  overflow-x: hidden;
  $box-height: 36px;
  @media only screen and (max-width: 600px) {
    /* xs */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 960px) and (min-width: 600px) {
    /* sm */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 1264px) and (min-width: 960px) {
    /* md */
    max-height: $box-height * 3;
  }
  @media only screen and (max-width: 1904px) and (min-width: 1264px) {
    /* lg */
    max-height: $box-height * 3;
  }
  @media only screen and (min-width: 1904px) {
    /* xl */
    max-height: $box-height * 3;
  }
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: grey;
}
</style>